import { APP_INITIALIZER, NgModule } from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppComponent} from './app.component';
import { setLicenseKey } from '@grapecity/wijmo';
import {WjGridModule} from '@grapecity/wijmo.angular2.grid';
import {CapMeldungService} from './cap/cap-meldung.service';
import {
    WS_BASE_URL, WS_SERVER_URL, DATEFORMAT_CULTURE, GEOSERVER_URL, WS_SERVICE_ENDPOINT, WS_SERVICE_ENDPOINT_URL,
    WS_SERVICE_VERSION_DEFAULT, WS_SERVICE_VERSION_DEFAULT_URL, WS_SERVICE_SCOPE_DEFAULT, WS_SERVICE_SCOPE_DEFAULT_VALUE,
    ENABLE_MANUAL_FEEDBACK, ENABLE_MANUAL_FEEDBACK_VALUE
} from './shared/tokens';
import {WindowRef} from './shared/window-ref.service';
import {CapMeldungComponent} from './cap/cap-meldung.component';
import {HttpClientModule} from '@angular/common/http';
import {MapComponent} from './map/map.component';
import {FormsModule} from '@angular/forms';

export function globalVarFactory(wr: WindowRef, globalVarName: string): string {
    return wr.getGlobalVarValue(globalVarName);
}

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        WjGridModule
    ],
    declarations: [
        AppComponent,
        CapMeldungComponent,
        MapComponent
    ],
    providers: [
        CapMeldungService,
        WindowRef,

        {provide: WS_SERVER_URL, useValue: 'WS_SERVER_URL'},
        {provide: WS_BASE_URL, useFactory: globalVarFactory, deps: [WindowRef, WS_SERVER_URL]},
        {provide: WS_SERVICE_ENDPOINT, useValue: 'WS_SERVICE_ENDPOINT'},
        {provide: WS_SERVICE_ENDPOINT_URL, useFactory: globalVarFactory, deps: [WindowRef, WS_SERVICE_ENDPOINT]},

        {provide: WS_SERVICE_VERSION_DEFAULT, useValue: 'WS_SERVICE_VERSION_DEFAULT'},
        {provide: WS_SERVICE_VERSION_DEFAULT_URL, useFactory: globalVarFactory, deps: [WindowRef, WS_SERVICE_VERSION_DEFAULT]},

        {provide: WS_SERVICE_SCOPE_DEFAULT, useValue: 'WS_SERVICE_SCOPE_DEFAULT'},
        {provide: WS_SERVICE_SCOPE_DEFAULT_VALUE, useFactory: globalVarFactory, deps: [WindowRef, WS_SERVICE_SCOPE_DEFAULT]},

        {provide: ENABLE_MANUAL_FEEDBACK, useValue: 'ENABLE_MANUAL_FEEDBACK'},
        {provide: ENABLE_MANUAL_FEEDBACK_VALUE, useFactory: globalVarFactory, deps: [WindowRef, ENABLE_MANUAL_FEEDBACK]},

        {provide: GEOSERVER_URL, useValue: 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'},
        {provide: DATEFORMAT_CULTURE, useValue: 'de-DE'},

        {
            provide: APP_INITIALIZER,
            useValue: () => setLicenseKey('AtosAG,193598485831659#B02d3cGSTZ5ZO34Q5dHeNhGW4pFNXh5UwBDa7d7V8s6bllnNB36QxImQpVlSjdXVqFkWzATeJFkYyIlMQBXW4FzMsVjN4lzL5JzcxtiMwJWQiNVNr2EOBdEdGJWblRmZup7Y7gEdQl5VnFlczQ6anhzKTBXd4N7ZMJFNrB7SZB7UrcjR5UWZNZlez46YJhGVxdFVB5GerZFWwNlToZlb8EnaCdENvcGUTRWOTFUdZNHNVBDNLd7VP56M5ADUMZURiJUTTlTYCR4KOZXRMdkZKFVRG3UW6UUa9syUQllYOtEVFpkI0IyUiwiI7gDMwcjNycjI0ICSiwCN5ATOxcjN7ETM0IicfJye35XX3JyMDBjQiojIDJCLiUmcvNEIv5mapdlI0IiTis7W0ICZyBlIsICOyETM8ADI6ADOwAjMwIjI0ICdyNkIsIyRBBycvRXQiojIh94QiwiI9UjNxMDO5gDN8kTNzkTMiojIklkIs4nIzYXOxAjMiojIyVmdiwSZzxWYmpjIyNHZisnOiwmbBJye0ICRiwiI34TQNFzLJR5QkNka8Z5NY9mY7oGRaRlav2yR42WQQpmbX5GbkVTSsVmbmdFc8tyZrM7aGZTSX9Wan94Uy2GS58Ed7g4NYtWV8tmdHBHNkFEbBdUM8wGMZtUTaJjciVHTj9UWDZmUzgzVXhGW7BzTxlEaTZARZd'),
            multi: true,
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
